import { useState } from "react";
import { useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
import { Input, Button, Form, message } from "antd";
import { UserOutlined, KeyOutlined } from "@ant-design/icons";

import Fetch from "components/Fetch";
import { mainColor } from "common";

export default function Login() {
  const history = useHistory();
  const cookies = new Cookies();

  const [loading, setLoading] = useState(false);

  const onSubmit = (data) => {
    setLoading(true);
    console.log(data);
    Fetch.post(
      "/register",
      {
        ...data,
        data: JSON.stringify({}),
        notifications: JSON.stringify({}),
        orders: JSON.stringify({}),
      },
      (res) => {
        console.log(res);
        if (res.message === "User successfully registered!") {
          cookies.set("__token", res.data.token, { path: "/" });
          message.success("ثبت نام با موفقیت انجام شد");
          history.push("/dashboard/index");
        }

        res.message?.email && message.error(res.message.email);
        res.message?.password && message.error(res.message.password);
        res.message?.name && message.error(res.message.name);
        res.message?.phone && message.error(res.message.phone);

        setLoading(false);
      }
    );
  };

  return (
    <>
      <Form onFinish={onSubmit}>
        <h1> ثبت نام</h1>

        <Form.Item
          name="name"
          rules={[
            {
              required: true,
              message: "لطفا نام و نام خانوادگی خود را وارد کنید!",
            },
          ]}
        >
          <Input
            size="large"
            placeholder="نام و نام خانوادگی"
            suffix={<UserOutlined />}
            style={{ marginTop: 12 }}
          />
        </Form.Item>
        <span style={{ color: "gray" }}>
          *لطفا ایمیل خود را با دقت وارد نمائید
        </span>
        <Form.Item
          name="email"
          rules={[{ required: true, message: "لطفا ایمیل خود را وارد کنید!" }]}
        >
          <Input
            size="large"
            placeholder="ایمیل"
            suffix={<UserOutlined />}
            style={{ marginTop: 4 }}
          />
        </Form.Item>

        <Form.Item
          name="phone"
          rules={[{ required: true, message: "لطفا تلفن خود را وارد کنید!" }]}
        >
          <Input
            size="large"
            placeholder="تلفن"
            suffix={<UserOutlined />}
            style={{ marginTop: 12 }}
          />
        </Form.Item>
        <Form.Item
          name="address"
          rules={[{ required: true, message: "لطفا آدرس  خود را وارد کنید!" }]}
        >
          <Input
            size="large"
            placeholder="آدرس"
            suffix={<UserOutlined />}
            style={{ marginTop: 12 }}
          />
        </Form.Item>
        <Form.Item
          name="password"
          rules={[
            { required: true, message: "لطفا رمز عبور خود را وارد کنید!" },
          ]}
        >
          <Input
            size="large"
            placeholder="رمز عبور"
            suffix={<KeyOutlined />}
            style={{ marginTop: 12 }}
          />
        </Form.Item>
        <Form.Item
          name="confirm_password"
          rules={[
            {
              required: true,
              message: "لطفا تکرار رمز عبور خود را وارد کنید!",
            },
          ]}
        >
          <Input
            size="large"
            placeholder="تکرار رمز عبور"
            suffix={<KeyOutlined />}
            style={{ marginTop: 12 }}
          />
        </Form.Item>
        <Button
          htmlType="submit"
          shape="round"
          size={"large"}
          style={{
            marginTop: 22,
            background: mainColor,
            border: "none",
            color: "#222",
          }}
          loading={loading}
        >
          <span style={{ padding: "0 12px" }}>ثبت نام</span>
        </Button>
        <p style={{ marginTop: 12 }}>
          ثبت نام کرده اید؟{" "}
          <a href="/auth/login" style={{ marginTop: 16 }}>
            وارد شوید
          </a>
        </p>
        <p style={{ marginTop: 12 }}>
          رمزعبور خود را فراموش کرده اید؟{" "}
          <a href="/auth/forget-password" style={{ marginTop: 16 }}>
            بازیابی رمزعبور
          </a>
        </p>
      </Form>
    </>
  );
}
